export default __webpack_public_path__ + "static/media/3-Cloudxier-PTSTP.c6289484.png";